import { Box } from "@mui/material";
import {
  CmpTypographyField,
  CmpTextField,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import moment from "moment";

export default function WmsHead({ xref, vRdxHead, xErrorMsg }) {
  return (
    <Box
      sx={{
        width: "100%",
        p: 2,
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      <form id="WmsStockAdjustmentHead">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={1.5}
              alignItems="center"
            >
              <Grid item xs={12} sm={2} md={2}>
                <CmpTypographyField xText="Doc.Type" />
              </Grid>
              <Grid item xs={12} sm={3} md={3}>
                <CmpTextField
                  xValue={vRdxHead.DocType}
                  xReadOnly
                  xTextAlign="center"
                />
              </Grid>
              <Grid item xs={12} sm={7} md={7}>
                <CmpTextField
                  xValue={vRdxHead.DocTypeName}
                  xReadOnly
                  xTextAlign="center"
                />
              </Grid>

              <Grid item xs={12} sm={2} md={2}>
                <CmpTypographyField xText="From Loc" />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <CmpTextField xValue={vRdxHead.LocName} xReadOnly />
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <CmpTypographyField xText="To Loc" />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <CmpTextField xValue={vRdxHead.LocNameTo} xReadOnly />
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <CmpTypographyField xText="Doc No" />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <CmpTextField xValue={vRdxHead.DocNo} xReadOnly />
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <CmpTypographyField xText="Date" />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <CmpTextField
                  xValue={moment(vRdxHead.Date).format("DD/MM/YYYY")}
                  xReadOnly
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
